
import offer from "@/apollo/queries/offer/offer";
import filters from "@/mixins/filters";
import jsonld from "@/mixins/jsonld";
import { mapActions, mapGetters, mapMutations } from "vuex";
// import { Component } from "@fancyapps/ui/types/shared/Base/Component";
// import { closingOfElementWithOpenChildElements } from 'parse5/lib/common/error-codes';

export default {
  mixins: [jsonld, filters],
  props: {
    pageTitle: String,
    description: String,
    crumbs: Array
  },
  data() {
    return {
      jsonType: "car",
      showFixed: false,
      stateScroll: false,
      location: null,

      allBlocks: [
        { title: "КОМПЛЕКТАЦИИ", component: "car-complectation2" },
        { title: "ХАРАКТЕРИСТИКИ", component: "car-tech2" },
        { title: "ПРЕИМУЩЕСТВА", component: "car-benefits" }
      ],
      chosenBlock: "car-complectation2"
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    //  setTimeout(()=>{this.stateScroll = true},2000)
    window.addEventListener("scroll", () => {
      if (window.scrollY >= 432) {
        this.stateScroll = true;
      } else {
        this.stateScroll = false;
      }
    });
    this.fetchData();
  },
  async fetch() {
    if (Number(this.$route.params.car)) {
      let variables = {
        site_id: this.site_id,
        mark_slug: this.$route.params.mark,
        folder_slug: this.$route.params.model,
        dateFormat: "j F Y года.",
        external_id: Number(this.$route.params.car)
      };
      let response = await this.request({
        query: offer,
        variables: variables
      });
      await this.setOffer(response.data.offer);
      await this.sendYandexCommercial();
      await this.sendVkPixel();
    }
  },
  computed: {
    ...mapGetters({
      // domain: 'domain',
      site_id: "site_id",
      offer: "catalog/catalog-cars/offer",
      carPageLoaded: "catalog/catalog-cars/carPageLoaded",
      benefitsCar: "benefits/benefitsCar",
      marks: "marks/marks/allMarks",
      likesArray: "favorite/favorite/likesArray",
      settings: 'settings/settings/settings',
      // focusShowFixed: 'car/car/focusShowFixed'

      benefitsSlider_credit: "benefits/benefitsSlider_card",

      benefitsCredit: "benefits/benefitsCredit",
      benefitsCredit_slider: "benefits/benefitsCredit_slider",
      benefits_autoCredit: "benefits/benefits_autoCredit"
    }),
    isNewCar() {
      return this.offer.run < 100;
    },
    currentLocation() {
      return this.location?.city ? `г. ${this.location.city}` : this.location?.region?.with_type;
    },
    isShowLocation() {
      return (this.location?.city || this.location?.region) && (this.location?.city !== this.settings.city && this.location?.region?.title !== this.settings.city);
      // return true
    }
  },
  beforeMount() {
    // window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapMutations({
      setOffer: "catalog/catalog-cars/SET_OFFER",
      // setIsOfferClick: 'filters/filters/SET_IS_OFFER_CLICK',
      // setComponentCatalog: 'filters/filters/SET_COMPONENT_CATALOG',
      setCarPageLoaded: "catalog/catalog-cars/SET_CAR_PAGE_LOADED"
    }),
    ...mapActions({
      liked: "favorite/favorite/liked",
      request: "filters/filters/request",
      openModal: "modal/modal-main/openModal"
    }),
    fetchData() {
      // const ip = '188.65.105.60'; // для разработки ip Москвы
      const ip = undefined;
      // const ip = process.env.NODE_ENV ? '188.65.105.60' : undefined
      this.$axios.$post('https://tione.api-used.ru/api/dadata/iplocate/address', { ip })
        .then((response) => {
          this.location = response.data;
        });
    },
    async autoteka(carInfo) {
      let payload = {
        modal_data: carInfo,
        modal_component: "modal-autoteka",
        modal_title: "Отчет от " + carInfo.createdAt,
        modal_sub_title: carInfo.name
      };
      await this.openModal(payload);
    },
    sendVkPixel() {
      if (process.client && this.offer) {
        _tmr.push({
          type: "reachGoal",
          id: this.settings.vk_pixel,
          value: this.offer.price,
          goal: "viewProduct",
          params: {
            product_id: this.offer.external_id
          }
        });
      }
    },
    sendYandexCommercial() {
      if (process.client && this.offer) {
        dataLayer.push({
          ecommerce: {
            detail: {
              products: [
                {
                  id: this.offer.external_id,
                  name: `${this.offer.mark.title} ${this.offer.folder.title}, ${this.offer.year} года, ${this.offer.gearbox.title}, ${this.offer.price} руб. - ${this.offer.external_id}`,
                  price: this.offer.price,
                  brand: this.offer.mark.title,
                  category: `${this.isNewCar?'Новые':'С пробегом'}/${this.offer.mark.title}/${this.offer.folder.title}/${this.offer.name}`,
                  quantity: 1
                }
              ]
            }
          }
        });
      }
    },
    callbackMobile() {
      let payload = {
        modal_data: this.offer,
        modal_component: "modal-callback",
        modal_title: "Заказать звонок",
        modal_sub_title: this.offer.name
      };
      this.openModal(payload);
    },
    callbackDesktop() {
			let payload = {
				modal_component: 'modal-callback-main',
			}
			this.openModal(payload)
    },
    handleScroll() {
      this.showFixed =
        process.client && this.$device.isMobile && window.scrollY > 369;
    },
    async like() {
      await this.liked(this.offer.external_id);
    }
  }
};
